import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ConnectivityService } from '../../services/connectivity.service';
import { OfflineOutboxService } from '../../services/offline-outbox.service';
import { PlatformService } from '../../services/platform.service';

@Component({
  selector: 'app-offline-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (showOfflineBanner) {
      <div class="offline-banner" role="status">
        <i class="pi pi-wifi-off"></i>
        <span>Offline — changes will sync when connected</span>
        @if (pendingCount > 0) {
          <span class="offline-pending">({{ pendingCount }} pending)</span>
        }
      </div>
    }
  `,
  styles: [
    `
      .offline-banner {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        background: #fff4e5;
        color: #8a4b00;
        border-bottom: 1px solid #f5d9a8;
        font-size: 0.875rem;
        font-weight: 600;
      }

      .offline-pending {
        font-weight: 700;
      }
    `
  ]
})
export class OfflineBannerComponent {
  private connectivity = inject(ConnectivityService);
  private outbox = inject(OfflineOutboxService);
  private platform = inject(PlatformService);

  showOfflineBanner = false;
  pendingCount = 0;

  constructor() {
    if (!this.platform.isNativeMobile) {
      return;
    }

    this.connectivity.isOnline$.subscribe((online) => {
      this.showOfflineBanner = !online;
      if (!online) {
        void this.refreshPendingCount();
      }
    });
  }

  private async refreshPendingCount(): Promise<void> {
    this.pendingCount = await this.outbox.getPendingCount();
  }
}
